import {gsap} from "gsap";
import {SplitText as SplitTextPlugin} from "gsap/SplitText";
import {ScrollTrigger} from "gsap/ScrollTrigger";

export class SplitLine {
  constructor() {
    this._elements = document.querySelectorAll("[animation-split-line]");
    this.init();
  }

  init() {
    gsap.registerPlugin(SplitTextPlugin);
    gsap.registerPlugin(ScrollTrigger);
    if (!this._elements) return;

    if (window.innerWidth > 768) {
      this._elements.forEach((el) => {
        el.style.opacity = "1";


        const split = SplitTextPlugin.create(el, {
          type: "lines",
          mask: "lines",
          autoSplit: true,
        });

        gsap.from(split.lines, {
          duration: 1,
          y: 100,
          opacity: 0,
          transform: 'rotate(5deg) translateX(10px)',
          autoAlpha: 0,
          stagger: 0.2,
          delay: 0.5,
          scrollTrigger: {
            trigger: el,
            start: "top bottom",
            end: "bottom 65%",
            scrub: 1,
          },
        });
      });
    }
  }
}
